export const arrays = {
  TipoPessoa: [
    { value: 1, text: 'Pessoa Física' },
    { value: 2, text: 'Pessoa Jurídica' }
  ],
  SchemaGridRelatorios: [
    { text: 'Ação', value: 'acao' },
    { text: 'Definição', value: 'definicao' }
  ],
  ItemsGridRelatorios: [
    {
      acao: 'Requisitar Arquivo',
      definicao:
        'Após selecionar o filtro, o arquivo é colocado numa fila para ser processado e montado'
    },
    {
      acao: 'Download',
      definicao:
        'Com a chave enviado por email, você pode fazer download do arquivo requisitado'
    }
  ],
  TabelasControleOperacao: [
    { text: 'Base de Cálculo', value: 1 },
    { text: 'Proposta Parcela', value: 2 },
    { text: 'Saldo de Parcela', value: 3 },
    { text: 'Saldo de Contrato', value: 4 },
    { text: 'PDD', value: 5 },
    { text: 'Proposta Antiga', value: 6 },
    { text: 'Evento Contábil', value: 7 },
    { text: 'Proposta RBM', value: 8 },
    { text: 'Cessao', value: 9 }
  ],
  StatusControleOperacao: [
    { text: 'Processando', value: 0 },
    { text: 'Finalizado', value: 1 },
    { text: 'Erro', value: 2 }
  ],
  TipoOperacao: [
    { text: 'Insert', value: 1 },
    { text: 'Update', value: 2 },
    { text: 'Delete', value: 3 }
  ],
  Decendio: [
    { text: 'Sem decêndio (mês todo)', value: 0 },
    { text: '1° Decêndio (dias 1 a 10)', value: 1 },
    { text: '2° Decêndio (dias 11 a 20)', value: 2 },
    { text: '3° Decêndio (dias 21 a último dia mês)', value: 3 }
  ]
};
